export default __webpack_public_path__ + "static/claire-e27e3301f05c9070883fa0e7f7d1378d.png";